import styled, { css } from 'styled-components';
import colors from '../../../../includes/colors';

export const BodySection = styled.div`
  a.big {
    font-size: 16px;
  }
  h2,
  h3 {
    font-size: 1.25rem;
    font-weight: 300;
    line-height: 1.875rem;
    margin-bottom: 0.25rem;
  }
  font-weight: 400;
  font-size: 0.875rem;
  ul,
  li {
    font-size: 1rem;
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: 0.875rem;
  }
  ul {
    margin-bottom: 20px;
  }
  li {
    padding: 0 0 0 22px;
    position: relative;
    &:not(:last-child) {
      margin-bottom: 0.5rem;
    }
    &:before {
      position: absolute;
      left: 0;
      font-family: dds-icons;
      font-size: 1.15rem;
      color: ${colors.blue};
      margin-right: 0.4rem;
      font-style: normal;
      font-weight: 400;
      font-variant: normal;
      text-transform: none;
      line-height: 1;
      -webkit-font-smoothing: antialiased;
      content: '';
    }
  }
`;

export const Item = styled.article`
  border-style: solid;
  border-color: ${colors.gray};
  border-width: 1px;
  padding-top: 1.5rem;
  padding-bottom: 1.25rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  position: relative;
  background-color: ${colors.white};
  width: 100%;
  height: 100%;

  .dds__icons {
    font-family: dds-icons;
    font-size: 1.15rem;
    color: ${colors.blue};
    margin-right: 0.4rem;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
  }
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 8px;
    width: calc(100% + 2px);
    margin-left: -1px;
    margin-top: -1px;

    ${props =>
      props.theme === 'YELLOW' &&
      css`
        background-color: ${colors.yellow};
      `}

    ${props =>
      props.theme === 'PURPLE' &&
      css`
        background-color: ${colors.purple};
      `}

    ${props =>
      props.theme === 'GREEN' &&
      css`
        background-color: ${colors.green};
      `}
  }

  @media (min-width: 768px) {
    display: block;
  }
`;

export const Header = styled.header``;

export const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 1.875rem;
  margin-bottom: 0.25rem;

  ${props =>
    props.small &&
    css`
      font-size: 1.25rem !important;
    `}

  ${props =>
    props.marginBottom &&
    css`
      margin-bottom: 0.5rem;
    `}

  @media (min-width: 576px) {
    font-size: 1.625rem;
  }

  @media (min-width: 768px) {
    font-size: 1.75rem;
  }
  
  @media (min-width: 992px) {
    min-height: 60px;
  }
`;

export const Paragraph = styled.p`
  font-weight: 400;
  font-size: 1rem;
  margin: 0;

  ${props =>
    props.small &&
    css`
      font-size: 0.875rem;
    `}

  ${props =>
    props.big &&
    css`
      font-size: 1.12rem;
      font-weight: 300;

      @media (min-width: 768px) {
        font-size: 1.36rem;
      }

      @media (min-width: 992px) {
        font-size: 1.5rem;
      }
    `}

  ${props =>
    props.flex &&
    css`
      display: flex;
    `}

  ${props =>
    props.center &&
    css`
      align-items: center;
    `}

  ${props =>
    props.flexStart &&
    css`
      align-items: start;
    `}

  ${props =>
    props.marginBottom &&
    css`
      margin-bottom: 0.5rem;
    `}
  
  @media (min-width: 992px) {
    min-height: 42px;
  }
`;
export const SmallDescription = styled.p`
  color: #444;
  font-size: 11px;
`;
export const Description = styled.p`
  font-weight: 400;
  font-size: 0.875rem;
  margin-bottom: 0;
  ul,
  li {
    font-size: 1rem;
    padding: 0;
    margin: 0;
    list-style: none;
  }
  li {
    padding: 0 0 10px 0;
  }
`;

export const Icon = styled.span`
  font-family: dds-icons;
  font-size: 1.15rem;
  color: ${colors.blue};
  margin-right: 0.4rem;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
`;

export const Picture = styled.picture`
  display: block;
  display: flex;
  justify-content: center;
`;

export const Link = styled.a`
  font-size: .87rem;
  white-space: nowrap;

  ${props =>
    props.marginTop &&
    css`
      margin-top: 0.5rem;
    `}

  ${props =>
    props.block &&
    css`
      display: block;
    `}

  ${props =>
    props.marginBottom &&
    css`
      margin-bottom: 0.5rem;
    `}

  ${props =>
    props.large &&
    css`
      @media (min-width: 480px) {
        font-size: 1rem;
      }
    `}

  ${props =>
    props.marginRight &&
    css`
      margin-right: 0.7rem;
    `}

  @media (min-width: 480px) {
    margin-top: 0;
  }


`;
export const Image = styled.img`
  max-width: 250px;
`;
export const Strong = styled.strong``;
export const Section = styled.section`
  display: flex;
  flex-flow: column;
  justify-content: center;

  a {
    text-decoration: underline;
  }

  ${props =>
    props.flexBasis &&
    css`
      @media (min-width: 768px) {
        flex-basis: ${props.flexBasis};
      }

      @media (min-width: 992px) {
        flex-basis: 100%;
      }
    `}
`;
export const Footer = styled.div`
  margin-bottom: 2px;
  ${props =>
    props.flex &&
    css`
      @media (min-width: 480px) {
        display: flex;
      }
    `}

  ${props =>
    props.center &&
    css`
      @media (min-width: 480px) {
        align-items: center;
      }
    `}

  ${props =>
    props.buttonMarginRight && 
    css`
      .btn {
        margin-right: 0.7rem;
      }
    `}
`;

export const List = styled.ul`
  list-style-type: none;
  padding: 0;

  ${props =>
    props.marginBottom &&
    css`
      margin-bottom: 1rem;
    `}
`;
export const ListItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`;
export const Divider = styled.hr`
  border-color: ${colors.gray};
  flex-basis: 100%;
`;

export const ButtonFill = styled.a`
  font-size: 0.875rem;
  padding-left: 0.6rem;
  padding-right: 0.6rem;
  text-decoration: none !important;
  color: #fff;
  background-color: ${colors.blue};
  border: solid 1px transparent;
  border-color: ${colors.blue};
  margin-right: 0.7rem;
  padding: .5rem 1rem;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;

  :hover {
    background-color: ${colors.darkBlue};
    color: #fff;
  }

  ${props =>
    props.marginBottom &&
    css`
      margin-bottom: 1rem;
    `}
`;

export const ButtonOutline = styled.a`
  font-size: 0.875rem;
  padding-left: 0.6rem;
  padding-right: 0.6rem;
  text-decoration: none !important;
  color: ${colors.blue};
  background-color: transparent;
  border: solid 1px transparent;
  border-color: ${colors.blue};
  margin-right: 0.7rem;
  padding: .5rem 1rem;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;

  :hover {
    color: #fff;
    background-color: ${colors.blue};
    border-color: ${colors.blue}
  }

  ${props =>
    props.marginBottom &&
    css`
      margin-bottom: 1rem;
    `}
`;